import {
  faPaperPlane,
  faArrowRightArrowLeft,
  faMapLocationDot,
  faSliders,
  faBuildings,
  faArrowRotateRight,
  faPlay,
  faPause,
  faEllipsisVertical,
  faBars,
  faImage,
  faArrowDownToLine,
  faCircleQuestion,
  faCircleLocationArrow,
  faArrowLeft,
  faEarthEurope,
  faLink,
  faPalette,
  faTag,
  faBedFront,
  faMoneyBill1Wave,
  faHouse,
  faKey,
  faXmark,
  faCalendarClock,
  faLocationDot,
} from '@fortawesome/pro-light-svg-icons';

import {
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faListUl,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faBars as faBarsSolid,
  faHeart as faHeartSolid,
  faGridRound2,
  faCarMirrors,
  faBicycle,
  faPersonWalking,
  faDownload,
} from '@fortawesome/pro-solid-svg-icons';
import { faHeart } from '@fortawesome/sharp-light-svg-icons';

export const fontAwesomeIconSet = {
  share: faPaperPlane,
  compare: faArrowRightArrowLeft,
  compare3: faArrowRightArrowLeft,

  chevronDown: faChevronDown,
  chevronUp: faChevronUp,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,

  list: faListUl,

  modelover: faMapLocationDot,
  filters: faSliders,
  buildings: faBuildings,
  rightarrowrotate: faArrowRotateRight,

  play: faPlay,
  pause: faPause,
  ellipsisvertical: faEllipsisVertical,

  three_bars: faBars,
  three_bar: faBarsSolid,

  grid: faGridRound2,

  close: faXmark,

  units: faHouse,
  news: faLocationDot,

  gallery: faImage,
  downloadmaterial: faArrowDownToLine,
  faq: faCircleQuestion,

  heart_full: faHeartSolid,
  heart_empty: faHeart,

  compas: faCircleLocationArrow,
  back: faArrowLeft,

  globe: faEarthEurope,
  link: faLink,
  status: faPalette,
  boligtype: faTag,

  rooms: faBedFront,
  price: faMoneyBill1Wave,
  floor: faHouse,
  orentation: faCircleLocationArrow,

  driving: faCarMirrors,
  cycling: faBicycle,
  walking: faPersonWalking,

  "event-calendar": faCalendarClock,
  "event-label": faTag,
  "event-pin": faLocationDot,

  "download-btn": faDownload,

  house: faHouse,
  key: faKey,
};